import React from 'react';
import { LinkV2 } from '../../../LinkV2';
import ZolaBabyLogo from '../../../ZolaBabyLogo';
import {
  AppLinkWrapper,
  ButtonsWrapper,
  StyledH5,
  ZolaInfoWrapper,
  SocialWrapper,
  SocialHandle,
} from './ZolaInfo.styles';
import appStoreBadge from '../../../../assets/images/footer/app-store-badge.svg';
import { BrandInstagramIcon } from '../../../SvgIconsV3/BrandInstagram';
import COLORS from '../../../../styles/emotion/colorsBaby';

const ZolaInfo = (): JSX.Element => {
  return (
    <ZolaInfoWrapper>
      <ZolaBabyLogo color={COLORS.BLACK_100} />
      <StyledH5>For all the days along the way</StyledH5>
      <ButtonsWrapper>
        <AppLinkWrapper>
          <LinkV2
            href="https://apps.apple.com/app/apple-store/id6446598574?pt=31209800&ct=zola_web_footer&mt=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStoreBadge} alt="Download On The App Store" />
          </LinkV2>
        </AppLinkWrapper>
      </ButtonsWrapper>
      <SocialWrapper>
        <LinkV2
          href="https://www.instagram.com/zolababy"
          aria-label="Instagram"
          target="_blank"
          rel="noopener noreferrer"
          subtle
          noUnderline
          noTextTransform
        >
          <BrandInstagramIcon title="Instagram" aria-hidden="true" height={24} width={24} />
          <SocialHandle>@zolababy</SocialHandle>
        </LinkV2>
      </SocialWrapper>
    </ZolaInfoWrapper>
  );
};

export default ZolaInfo;
